import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdvertisePackage } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchAdvertisePackage,
  FindAdvertisePackage,
  GetAdvertisePackage,
} from './interface';

export const findAdvertisePackage = createAsyncThunk(
  'advertisePackage/findAdvertisePackage',
  async (values: FindAdvertisePackage, { rejectWithValue }) => {
    try {
      const response = await AdvertisePackage.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createAdvertisePackage = createAsyncThunk(
  'advertisePackage/createAdvertisePackage',
  async (values: CreatePatchAdvertisePackage, { rejectWithValue }) => {
    try {
      const response = await AdvertisePackage.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchAdvertisePackage = createAsyncThunk(
  'advertisePackage/patchAdvertisePackage',
  async (
    { id, ...values }: CreatePatchAdvertisePackage,
    { rejectWithValue }
  ) => {
    try {
      const response = await AdvertisePackage.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAdvertisePackage = createAsyncThunk(
  'advertisePackage/getAdvertisePackage',
  async ({ id }: GetAdvertisePackage, { rejectWithValue }) => {
    try {
      const response = await AdvertisePackage.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
